import { IItemPrice } from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';
import { endOfDay, startOfDay } from 'date-fns';

export class ItemPrice implements IItemPrice {
  id!: string;
  entityType!: string;
  entityId!: string;
  type!: string;
  price!: number | null;

  @Type(() => Date)
  validFrom!: Date;

  @Type(() => Date)
  validTo!: Date | null;

  isActiveAt(date: Date | number): boolean {
    date = new Date(date);
    return (
      startOfDay(this.validFrom) <= date &&
      (!this.validTo || endOfDay(this.validTo) >= date)
    );
  }

  get isActive(): boolean {
    return this.isActiveAt(Date.now());
  }
}
